// ##############################
// // // LoginPage view styles
// #############################

import {
  container,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    }
    },
  cardTitle: {
    ...cardTitle,
      color: "black",
      fontSize: "23px",
      fontFamily: "none",
      textTransform: "uppercase",
      marginBottom: "9px"

    },
    headerLine: {
        border: "1px solid #e8e8e8",
        width: "84px",
        margin: " 0 auto",
        marginTop:"-10px"

    },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
        //position: "absolute",
        //width: "100%",
        //marginLeft: "-23px",
        //marginBottom:" 71px",
        //marginTop:" -60px",
        //borderRadius: "10px 10px 0px 0px !important",
        //boxShadow: "0 10px 15px - 3px rgba(0, 0, 0, 0.1), 0 4px 6px - 2px rgba(0, 0, 0, 0.05)",
        //background: "green"
  },
  socialLine: {
    padding: "0.9375rem 0"
    },
    footerText: {
        fontSize: "12px",
        position: "absolute",
        bottom: "0",
        color:"#7c947d"
    }
});

export default loginPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx